import { useMutation, useQueryClient } from '@tanstack/react-query';
import Config from 'src/common/Config';
import { UserStatus, UserRole } from '../types';

const API_URL = Config.getApiUrl();

type UpdateUserRequest = {
  firstName?: string;
  lastName?: string;
  emailAddress?: string;
  userRole?: UserRole;
  userStatus?: UserStatus;
};

export function useUpdateUser() {
  const queryClient = useQueryClient();

  const { mutateAsync, error, isLoading, reset } = useMutation({
    mutationFn: async ({ id, values }: { id: string; values: UpdateUserRequest }) => {
      const response = await fetch(`${API_URL}/users/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(values),
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      });

      if (response.status < 200 || response.status > 299) throw response;

      const data = await response.json();
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['users'] });
    },
  });

  const updateUser = async (id: string, values: UpdateUserRequest) => {
    return mutateAsync({ id, values });
  };

  return {
    updateUser,
    error,
    isLoading,
    reset,
  };
}
